$(document).ready(function () { 

    $('#preloader').fadeOut(300);

    $('.header-search').click(function(){
        var elem = $('.search-wrapper');
        elem.stop();
        elem.slideToggle(400);
    })

    $('.with-dropdown .toggler').click(function(){
        var elem     = $(this),
            dropdown = elem.next();

        dropdown.stop();
        dropdown.fadeToggle(150);

        dropdown.find('a').click(function(){
            var text = $(this).find('div').text();
            elem.text(text);
            dropdown.stop();
            dropdown.fadeOut(150);
        })

        $(document).mouseup(function (e){
            if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
                dropdown.stop();
                dropdown.fadeOut(150);
            }
        });

    })

    $('.bottom-header-content .search-submit').click(function(){
        var parent = $(this).parent(),
            input  = parent.find('input');

        if(!parent.hasClass('show')){
            event.preventDefault();
            parent.addClass('show');
            input.focus();
        }else{
            parent.removeClass('show');
        }

        $(document).mouseup(function (e){
            if (!parent.is(e.target) && parent.has(e.target).length === 0) {
                parent.removeClass('show');
            }
        });

    })

    $('.show-user-dropdown').click(function(){
        var wrapper  = $(this).parent(),
            dropdown = $('.user-dropdown'); 

        dropdown.stop();       
        dropdown.fadeToggle(300);
        wrapper.toggleClass('active');

        $(document).mouseup(function (e){
            if (!wrapper.is(e.target) && wrapper.has(e.target).length === 0) {
                dropdown.stop();
                wrapper.removeClass('active');
                dropdown.fadeOut(150);
            }
        });
    })

    $('.show-contacs').click(function(){
        $('.mobile-menu-content .contacts').stop();
        $('.mobile-menu-content .contacts').slideToggle(300);
    })

    $('.user h2').click(function(){
        var parent = $(this).parent(),
            list   = parent.find('ul');

        parent.toggleClass('show');
        list.slideToggle(300);
    })

    $('.anchor').click(function(){
        var elem = $('.' + $(this).data('link')),
            offset = elem.offset().top - ($(window).height() * 0.05);        

        $('html, body').animate({ 
            scrollTop: offset
        }, 700); 
    })

    $('.callback').click(function(){
        $('.callback-popup').fadeIn(300);
        $('.callback-popup .close-popup, .callback-blackboard').click(function(){
            $('.callback-popup').fadeOut(300);
        })
    })

    function toggle_mobile_links(){
        if($(window).scrollTop() >= 200){
            $('.mobile-links').addClass('show');
        }else{
            $('.mobile-links').removeClass('show');
        }   
    }

    toggle_mobile_links();
    $(window).on('scroll', toggle_mobile_links);

});